import ErrorBoundary from './error-boundary.component'

// SSR: Moved Error boundary component to error-boundary.component.tsx
function withErrorBoundary(Component: any, errorBoundaryProps = { FallbackComponent: () => <div /> }) {
  function Wrapped(props: any) {
    return (
      <ErrorBoundary {...errorBoundaryProps}>
        <Component {...props} />
      </ErrorBoundary>
    )
  }

  // Format for display in DevTools
  const name = Component.displayName || Component.name || 'Unknown'
  Wrapped.displayName = `withErrorBoundary(${name})`

  return Wrapped
}

export { ErrorBoundary, withErrorBoundary }
